import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { portalInfo, API } from "../../lib/api";
import { applyAccent } from "../../hooks/useBranding";

// Loads an advisor's white-label page info for ?portal=<slug> and applies their accent colour while on the page.
export const usePortal = (slug) => {
  const [portal, setPortal] = useState(null);
  useEffect(() => {
    if (!slug) return undefined;
    let alive = true;
    portalInfo(slug).then((p) => { if (alive) { setPortal(p); applyAccent(p.accent); } }).catch(() => {});
    return () => { alive = false; applyAccent(null); };
  }, [slug]);
  return portal;
};

export const PortalLogo = ({ portal, className = "h-10 w-10" }) => {
  const [broken, setBroken] = useState(false);
  return portal?.logo_url && !broken
    ? <img src={`${API.replace(/\/api$/, "")}${portal.logo_url}`} alt={portal.firm_name} onError={() => setBroken(true)} className={`${className} rounded-xl object-contain bg-card border border-border`} data-testid="portal-logo" />
    : <div className={`${className} rounded-xl bg-primary text-primary-foreground grid place-items-center`}><Building2 className="h-5 w-5" /></div>;
};

export const PortalBanner = ({ portal }) => portal ? (
  <div data-testid="welcome-portal-banner" className="rounded-xl border border-primary/30 bg-primary/5 px-3 py-2 text-xs flex items-center gap-3">
    <PortalLogo portal={portal} className="h-8 w-8" />
    <div>Setting up with <b>{portal.firm_name}</b>. You own the vault; {portal.firm_name} gets read-only access you can switch off any time{portal.open ? "" : " — their page is currently full"}.</div>
  </div>
) : null;
